export default "__VITE_ASSET__C6Obl7IJ__"